// src/hr/kit/util.js -- small helpers shared by the kit components.
import React from 'react';

// Joins class names, skipping falsy values.
export function cx(...names) {
  return names.filter(Boolean).join(' ');
}

// Icons may be passed as a component (FiClock) or as an element (<FiClock />).
export function renderIcon(icon, props) {
  if (!icon) return null;
  if (React.isValidElement(icon)) return icon;
  return React.createElement(icon, props);
}

// React's useId() contains ':' characters; ids used in url(#...) and selectors stay plain.
export function plainId(id) {
  return String(id).replace(/[^a-zA-Z0-9_-]/g, '');
}

// '#818cf8' / '#8cf' -> { r, g, b }, or null.
export function parseHex(hex) {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex || '').trim());
  if (!m) return null;
  const h = m[1].length === 3 ? m[1].split('').map((c) => c + c).join('') : m[1];
  return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) };
}

// Mixes a color toward white (amount 0..1); used for readable text on a tinted dark surface.
export function towardWhite({ r, g, b }, amount) {
  const mix = (c) => Math.round(c + (255 - c) * amount);
  return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
}
